"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = void 0;
var Preact = __importStar(require("preact"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var FormHelperText_1 = __importDefault(require("@mui/material/FormHelperText"));
var InputAdornment_1 = __importDefault(require("@mui/material/InputAdornment"));
var TextField = __importStar(require("./A_InputField"));
var Component = function (p) {
    var endAdornment = p.unit ? Preact.h(InputAdornment_1.default, { position: "end" }, p.unit) : null;
    return (Preact.h(Box_1.default, { sx: p.sx },
        Preact.h(TextField.Component, { fullWidth: true, label: p.label, id: p.label, value: p.value, "aria-describedby": p.ariaDescribedBy, type: "text", autoComplete: "off", onChange: function (event) { return p.onValueChange(event.target.value); }, inputProps: { inputMode: 'numeric', pattern: '[0-9]*' }, InputProps: { endAdornment: endAdornment }, error: p.error !== undefined, sx: { ':focus': { borderColor: 'primary.main' } } }),
        p.error !== undefined ? (Preact.h(FormHelperText_1.default, { error: true }, p.error)) : (Preact.h(FormHelperText_1.default, { error: true }, " "))));
};
exports.Component = Component;
exports.Component.displayName = 'NumericInput';
